module.exports = __webpack_public_path__ + "img/schema_siegemoule_9b.1986a739.svg";